import React from 'react';

import { Layout } from 'components';

const wrapPageElement = ({ element, props }) => <Layout {...props}>{element}</Layout>;

export default wrapPageElement;
